import Icon from 'veui/components/Icon'
import { IconMotionGraphics } from 'dls-icons-vue'

Icon.register('motion-graphics', IconMotionGraphics)
